<div
	class="relative inline-block text-left"
	appClickedOutside
	(clickedOutside)="handleClickedOutside()"
>
	<button (click)="toggleDropdown()" type="button" class="cursor-pointer">
		<ng-content></ng-content>
	</button>
	<!-- <button
		(click)="toggleDropdown()"
		type="button"
		class="hidden lg:flex shadow-btn w-6 h-6 cursor-pointer items-center justify-center bg-white"
	>
		<ion-icon name="ellipsis-horizontal-outline" class="text-primary text-lg"></ion-icon>
	</button> -->

	<div
		[ngClass]="{ hidden: !isDropdownOpen, 'w-52': lgContainer}"
		class="origin-top-right absolute right-0 mt-2 rounded-md performance-custom-shadow bg-white z-3"
	>
		<div class="py-2 p-2" role="menu" aria-orientation="vertical" aria-labelledby="dropdown-button">
			<a
				*ngFor="let option of optionsList"
				class="flex rounded-md px-4 py-2 text-sm text-gray-800 hover:bg-gray-100 active:bg-primary_ultra_light_variant cursor-pointer"
				role="menuitem"
				(click)="onOptionSelected(option.id)"
			>
				{{ option.optionLabel }}
			</a>
		</div>
	</div>
</div>
